/** 使用者可選的三種主題模式（spec 21.4）。 */
export const THEME_MODES = ['light', 'dark', 'system'] as const;

export type ThemeMode = (typeof THEME_MODES)[number];

/** 實際套用到畫面的主題，system 會被解析成其中之一。 */
export type ResolvedTheme = 'light' | 'dark';

export function isThemeMode(value: unknown): value is ThemeMode {
  return typeof value === 'string' && (THEME_MODES as readonly string[]).includes(value);
}

export function resolveTheme(mode: ThemeMode, systemPrefersDark: boolean): ResolvedTheme {
  if (mode === 'system') {
    return systemPrefersDark ? 'dark' : 'light';
  }
  return mode;
}

/** 工具列的主題按鈕依 light → dark → system 循環。 */
export function nextThemeMode(mode: ThemeMode): ThemeMode {
  const index = THEME_MODES.indexOf(mode);
  return THEME_MODES[(index + 1) % THEME_MODES.length] ?? 'system';
}

export const THEME_MODE_LABELS: Record<ThemeMode, string> = {
  light: '淺色',
  dark: '深色',
  system: '跟隨系統',
};
